import React, { useImperativeHandle, forwardRef, useRef } from 'react'
import { useStyles } from './style'
import { Box, Drawer, IconButton } from '@mui/material'
import { ActionButton } from '../action-buttons'
import CloseIcon from '@mui/icons-material/Close'
import { useFormFactor, usePaidConsumer, useIsOnTrial } from '../../hooks'

const GleapChecklist = ({ id, open, setOpen, onSkip, showDismiss, userId }, ref) => {
  const { isPaidConsumer } = usePaidConsumer()
  const { isTrialBannerVisible } = useIsOnTrial()
  const { isMobile } = useFormFactor()
  const classes = useStyles({ isPaidConsumer, isMobile, isTrialBannerVisible })
  const checklistRef = useRef(null)

  useImperativeHandle(ref, () => ({
    close: () => {
      setOpen(false)
    },
    skip: onSkip,
    open: () => {
      setOpen(true)
    },
    isOpen: () => open
  }), [onSkip, open, setOpen])

  return (
    <Drawer
      open={open}
      className={classes.root}
      variant='persistent'
      anchor='right'
      data-test='gleap-checklist-drawer'
    >
      <Box className={classes.checklistContainer} data-test='gleap-checklist-container' ref={checklistRef}>
        {isMobile && (
          <Box display='flex' justifyContent='flex-end' position='absolute' top='16px' left='16px' data-test='gleap-checklist-close-button-container'>
            <IconButton
              aria-label='close'
              onClick={() => setOpen(false)}
              data-test='gleap-checklist-close-button'
            >
              <CloseIcon />
            </IconButton>
          </Box>
        )}
        <Box className={classes.skip} data-test='gleap-checklist-skip-button-container'>
          <ActionButton
            variant='text'
            label={showDismiss ? 'Don\'t show again' : 'Skip for now'}
            labelhover={showDismiss ? 'Don\'t show again' : 'Skip for now'}
            data-test='gleap-checklist-skip'
            onClick={onSkip}
          />
        </Box>
        <Box className={classes.checklistContent}>
          <gleap-checklist checklistid={id} sharedKey={userId} />
        </Box>
      </Box>
    </Drawer>
  )
}

export default forwardRef(GleapChecklist)
